import { useEffect, useState } from "react";

export default function StatsPage({ type }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`http://localhost:5001/stats/${type}`)
      .then(res => res.json())
      .then(setData)
      .catch(err => setData({ error: err.message }));
  }, [type]);

  return (
    <div style={{ padding: 20 }}>
      <h2>Gemini Usage Stats</h2>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
